import { Languages } from 'lucide-react';
import { TRANSLATION_INSTRUCTION } from './constants';
import InstructionActions from './InstructionActions';
import { IDLE_STYLES as styles } from './styles';

const TranslationSection = ({ onOpenInstruction }) => (
    <div className="aluminium-upload-panel aluminium-coming-soon" style={styles.panel}>
      <div className="aluminium-module-header">
        <div>
          <h3 className="aluminium-automation-title">Tłumaczenie ofert</h3>
        </div>
        <InstructionActions instruction={TRANSLATION_INSTRUCTION} onPreview={onOpenInstruction} />
      </div>
      <div className="aluminium-coming-soon-notice" role="status">
        <Languages aria-hidden="true" />
        <div><strong>Moduł w przygotowaniu</strong><span>Funkcja tłumaczenia ofert będzie dostępna po wdrożeniu.</span></div>
      </div>
      <div style={styles.row}>
        <button type="button" className="aluminium-file-button disabled" disabled>Wybierz ofertę</button>
        <button type="button" style={styles.button} disabled>Analizuj</button>
      </div>
    </div>
);

export default TranslationSection;
